import React from 'react';

import { HStack, VStack } from '@rtkwlf/fenrir-react';
import type { SpidrWithFocus } from '@rtkwlf/track-public';

import { SpidrBlueprintDetails } from './spidr-blueprint-details';
import { SpidrDetails } from './spidr-details';
import { SpidrDetailsHeader } from './spidr-details-header';

type SpidrDetailsPageProps = {
  spidr: SpidrWithFocus;
};

export const SpidrDetailsPage: React.FC<SpidrDetailsPageProps> = ({
  spidr,
}) => {
  return (
    <VStack gap="xlarge">
      <SpidrDetailsHeader
        id={spidr.id}
        version={spidr.version}
        name={spidr.blueprint.name}
        state={spidr.state}
        ticketId={spidr.ticketId}
        focus={spidr.securityFocus}
        deliveredAt={spidr.deliveredAt}
        expiryDate={spidr.expiryDate}
        tier={spidr.blueprint.tier}
        rating={spidr.rating}
        improvements={spidr.improvements}
      />
      <HStack
        width="full"
        alignItems="flex-start"
        justifyContent="space-between"
        gap="large"
      >
        <SpidrDetails
          customerActionItems={spidr.customerActionItems}
          customerRecommendations={spidr.customerRecommendations}
          cstActionItems={spidr.cstActionItems}
          noCstActionItems={spidr.noCstActionItems}
          noCustomerActionItems={spidr.noCustomerActionItems}
          attachments={spidr.attachments}
        />
        <SpidrBlueprintDetails blueprint={spidr.blueprint} />
      </HStack>
    </VStack>
  );
};
